/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.CASH_TRANCHE.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {
    FetchRequest,
    CashTrancheInput,
    CashTranche,
    UUID,
    WaterfallItemInput
} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object for creating a new cash tranche, including both the cash tranche and its associated waterfall item.
 * @param cashTrancheInput An object of type CashTrancheInput containing the input data for creating the cash tranche.
 * @param waterfallItemInput An object of type WaterfallItemInput containing the input data for the associated waterfall item.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_create_cash_tranche(cashTrancheInput: CashTrancheInput, waterfallItemInput: WaterfallItemInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CASH_TRANCHE,
        method: HttpMethods.POST,
        query_parameters: {},
        body: {
            waterfall_item: waterfallItemInput,
            cash_tranche: cashTrancheInput
        },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * cash_tranche on the server.
 * @param cash_tranche An object of type CashTranche containing the updated cash_tranche data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_cash_tranche(cash_tranche: CashTranche): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CASH_TRANCHE,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: cash_tranche,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of cash_tranches
 * on the server.
 * @param transaction_id .The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_cash_tranches(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CASH_TRANCHE,
        method: HttpMethods.GET,
        query_parameters:  { transaction_id: transaction_id }
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * cash_tranche on the server.
 * @param cash_tranche_id The UUID of the cash_tranche to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_cash_tranche(cash_tranche_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CASH_TRANCHE,
        method: HttpMethods.DELETE,
        query_parameters: { cash_tranche_id: cash_tranche_id},
    };
}
